import type { ReactElement, ReactNode, Ref } from "react";

import type { IconName, IconSize } from "@similarweb/icons";
import type { ButtonProps } from "@similarweb/swui";
import { IconButton } from "@similarweb/ui-components";
import type {
    ExportVariantsDropdownProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import {
    ExportVariantsDropdown
} from "app/pages/sales-intelligence/common-components/table-actions-panel";

interface IContactsExportDropdownProps {
    ref?: Ref<HTMLButtonElement>;
    isDisabled?: boolean;
    dataAutomation?: string;
    buttonText?: string;
    buttonIconName: IconName;
    buttonIconSize?: IconSize;
    children: ReactNode;
}

type Props = IContactsExportDropdownProps &
    Pick<ExportVariantsDropdownProps<ButtonProps>, "id" | "onClick" | "buttonTooltipProps">;

const ContactsExportDropdown = ({
    ref,
    isDisabled,
    buttonIconName,
    buttonIconSize,
    dataAutomation,
    buttonText,
    children,
    ...dropdownProps
}: Props): ReactElement => {
    return (
        <ExportVariantsDropdown
            button={
                <IconButton
                    ref={ref}
                    type="flat"
                    iconSize={buttonIconSize}
                    iconName={buttonIconName}
                    isDisabled={isDisabled}
                    dataAutomation={dataAutomation}
                    onClick={dropdownProps.onClick}
                >
                    {buttonText}
                </IconButton>
            }
            {...dropdownProps}
        >
            {children}
        </ExportVariantsDropdown>
    );
};

export default ContactsExportDropdown;
